var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = theme.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

async function fetchMultipleRequests(data, url) {
  for(const data_item of data) {
    await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json;'
      },
      body: JSON.stringify(data_item)
    })
    .then(response => response.json())
    .then(function(json) {
      // GTM Upsell subscription upgrade event
      if (dataLayer) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: 'upsell_subscription_upgrade',
          ecommerce: {
            items: json.items
          }
        });
      }
    });
  }
}

function initSectionProductSlider(element){
  if (element.hasClass('init-slider')){
    var slidesMobile = parseFloat(element.data('slides-mobile')) || 1.15;
    var slidesTablet = parseFloat(element.data('slides-tablet'));
    var slidesDesktop = parseFloat(element.data('slides-desktop'));
    var centerMode = !!element.data('center-mode');
    var showDots = element.data('show-dots');
    var wrapper = element.parents('.cfcat-container');
    var arrowPrev = wrapper.find('.cfcat-arrow-prev');
    var arrowNext = wrapper.find('.cfcat-arrow-next');
    element.slick({
      dots: showDots,
      arrows: true,
      infinite: false,
      mobileFirst: true,
      slidesToShow: slidesMobile,
      slidesToScroll: 1,
      prevArrow: arrowPrev,
      nextArrow: arrowNext,
      centerMode,
      centerPadding: '0px',
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: slidesTablet
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: slidesDesktop
          }
        }
      ]
    });
  }
}

document.addEventListener('DOMContentLoaded', function(){
  // Header scripts

  function set_element_height_into_variable(parent_container, element_to_measure, css_var_name) {
    height = $(element_to_measure).outerHeight(true);
    $(parent_container).css(`--${css_var_name}`, height + 'px');
  }

  if($('.ch-announcement-bar-container').length){
    set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
  }

  set_element_height_into_variable(':root', '.ch-container', 'header_height');

  $(window).on('load', function(){
    set_element_height_into_variable(':root', '.ch-container', 'header_height');
    if($('.ch-announcement-bar-container').length){
      set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
    }
    $('body').removeClass('not-loaded');

    if(window.location.hash) {
      setTimeout(function() {
        var scroll_to = $(window.location.hash).offset().top - $('.ch-container').outerHeight(true);

        if($('.ch-announcement-bar-container').length) {
          scroll_to = scroll_to - $('.ch-announcement-bar-container').outerHeight(true);
        }

        $('html, body').animate({
          scrollTop: scroll_to
        }, 800);
      }, 1);
    }
  });

  // setTimeout(function() {
  //   AOS.init({
  //     easing: 'ease',
  //     once: true,
  //     duration: 1000,
  //     offset: 60,
  //     disableMutationObserver: true,
  //   });
  // }, 300)

  $(window).on('resize', function(){
    if($('.ch-announcement-bar-container').length){
      set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
    };
    set_element_height_into_variable(':root', '.ch-container', 'header_height');
    // AOS.refreshHard();
  });

  function check_current_scroll_position() {
    current_scroll = $(window).scrollTop();
    if(current_scroll > 0) {
      $('.ch-container').addClass('scrolled');
    } else {
      $('.ch-container').removeClass('scrolled');
    }
  }

  check_current_scroll_position();

  $(window).on('scroll', function(){
    check_current_scroll_position()
  });

  $(document).on('click', '[data-toggle-mobile-menu]', function(){
    if ($('.mobile-menu-container').hasClass('opened')) {
      $('.mobile-menu-container').removeClass('opened');
      $('.ch-container').removeClass('mobile-menu-opened');
      $('html').removeClass('disable-scroll');
    } else {
      $('.mobile-menu-container').addClass('opened');
      $('.ch-container').addClass('mobile-menu-opened');
      $('html').addClass('disable-scroll');
      document.querySelector('search-drawer').setAttribute('aria-hidden', true);
    }
  });

  $(document).on('click', '[data-show-password]', function(){
    var parent = $(this).parent();
    var passwordInput = parent.find('.clogin-password');
    $(this).find('.visually-hidden').removeClass('visually-hidden');
    if(passwordInput[0].type == 'password'){
      passwordInput[0].type = 'text';
      $(this).find('.password-hidden').addClass('visually-hidden');
    } else {
      passwordInput[0].type = 'password';
      $(this).find('.password-shown').addClass('visually-hidden');
    }
  });

  // Footer scripts
  $(document).on('click', '[data-toggle-collapsible]', function(e) {
    e.preventDefault();
    collapsible_parent_container = $(this).parents('[data-collapsible-container]');
    $(this).toggleClass('opened');
    collapsible_parent_container.find('[data-collapsible-content]').slideToggle();
  });

  $(document).on('click', '[data-reveal-all-hidden-items]', function(e) {
    e.preventDefault();
    const section = $(this).parents('.shopify-section');
    section.find('[data-initially-hidden-item]').each(function(){
      $(this).fadeIn();
    });
    $(this).fadeOut();
  })

  // Banner slider
  if ($('.cbs-slider').length){
    $('.cbs-slider').each(function(){
      if ($(this).hasClass('init-slider')){
        var autoplay = $(this).data('autoplay');
        var autoplaySpeed = $(this).data('autoplay-speed');
        $(this).slick({
          dots: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed
        });
      }
    });
  }

  // Featured products slider
  if ($('.cfcat-grid').length){
    $('.cfcat-grid').each(function(){
      initSectionProductSlider($(this));
    });
  }

  document.addEventListener(
    'shopify:section:load',
    function(event) {
      const section = event.target;
      if (section.querySelector('.cfcat-grid')) {
        initSectionProductSlider($(section.querySelector('.cfcat-grid')));
      }
    }
  );

  // Insta slider
  if ($('.cis-slider').length){
    $('.cis-slider').each(function(){
      if ($(this).hasClass('init-slider')){
        var autoplay = $(this).data('autoplay');
        var autoplaySpeed = $(this).data('autoplay-speed');
        var wrapper = $(this).parent();
        var arrowPrev = wrapper.find('.cis-arrow-prev');
        var arrowNext = wrapper.find('.cis-arrow-next');
        $(this).slick({
          dots: false,
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          prevArrow: arrowPrev,
          nextArrow: arrowNext,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
              }
            }
          ]
        });
      }
    });
  }

  if ($('.ct-slider').length){
    $('.ct-slider').each(function(){
      if ($(this).hasClass('init-slider')){
        $(this).slick({
          dots: true,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    });
  }

  if ($('.ci-ingredients-slider').length){
    $('.ci-ingredients-slider').each(function(){
      var autoplay = $(this).data('autoplay');
      var autoplaySpeed = $(this).data('autoplay-speed');
      var arrows = $(this).data('arrows');
      if ($(this).hasClass('init-slider')){
        $(this).slick({
          dots: false,
          arrows: arrows,
          slidesToShow: 4,
          slidesToScroll: 1,
          speed: 500,
          touchThreshold: 50,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          responsive: [
            {
              breakpoint: 2000,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    });
  }

  $(document).on('click', '[data-toggle-popup]', function(e){
    e.preventDefault();
    popup = $(`[data-popup="${$(this).data('toggle-popup')}"]`);
    popup.fadeToggle().toggleClass('opened');
    $('html').toggleClass('disable-scroll');
  });

  $(document).on('click', '.cpt-popup-container', function(e){
		if(!$(e.target).parents('.cpt-popup-content').length){
			$('.cpt-popup-container').fadeToggle().toggleClass('opened');
			$('html').toggleClass('disable-scroll');
		}
	});

  // Swimlane
  if ($('.swimlane').length){
    $('.swimlane').each(function(){
      var swimlane = $(this)[0];
      let isDown = false;
      let startX;
      let scrollLeft;

      swimlane.addEventListener("mousedown", e => {
        isDown = true;
        swimlane.classList.add("active");
        startX = e.pageX - swimlane.offsetLeft;
        scrollLeft = swimlane.scrollLeft;
      });
      swimlane.addEventListener("mouseleave", () => {
        isDown = false;
        swimlane.classList.remove("active");
      });
      swimlane.addEventListener("mouseup", () => {
        isDown = false;
        swimlane.classList.remove("active");
      });
      swimlane.addEventListener("mousemove", e => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - swimlane.offsetLeft;
        const walk = x - startX;
        swimlane.scrollLeft = scrollLeft - walk;
      });
    });
  }

  // FAQ Page
  if ($('.custom-faq-page-faq-section').length){
    $(document).on('click','.fp-cpi-block', function(){
      category = $(this).data('category');
      $('.fp-cpi-block').removeClass('active');
      $('.fp-cpf-container').removeClass('visible');
      $(this).addClass('active');
      $('.fp-cpf-container[data-category="'+ category +'"]').addClass('visible');
      $('html,body').animate({
        scrollTop: $('.fp-cpf-container[data-category="'+ category +'"]').offset().top - $('.custom-header-section').outerHeight(true)
      }, 'slow');
    });
  }

  // Buttons
  $(document).on('click', '.custom-button', function(e){
    href = $(this).attr('href');
    if (href && href.includes('#')){
      e.preventDefault();
      $('html,body').animate({
        scrollTop: $(href).offset().top - $('.custom-header-section').outerHeight(true)
      }, 'slow');
    }
  });

  // Text with slider
  if ($('.cptwls-slider').length){
    $('.cptwls-slider').each(function(){
      if ($(this).hasClass('init-slider')){
        var autoplay = $(this).data('autoplay');
        var autoplaySpeed = $(this).data('autoplay-speed');
        $(this).slick({
          dots: false,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "90px",
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          mobileFirst: true,
          infinite: true,
          responsive: [
            {
               breakpoint: 767,
               settings: {
                 slidesToShow: 3,
                 slidesToSroll: 1,
                 centerPadding:"0px",
                 centerMode: true
               }
            }
          ]
        });

        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
          if (currentSlide != nextSlide){
            test_slider = $(this).parent().find('.cptwls-text-slider');
            test_slider.find('.cptwls-text').hide();
            test_slider.find('.cptwls-text[data-block-id="'+ nextSlide +'"]').fadeIn(500);
          }
        });
      }
    });
  }

  $(document).on('click', '[data-change-quantity]', function(e) {
    e.preventDefault();
    quantity_change = parseInt($(this).data('change-quantity'));
    quantity_input = $(this).parents('form').find('[name="quantity"]');
    if(!quantity_input.length) {
      quantity_input = $(this).parent().find('[name="updates[]"]');
    }
    current_quantity = parseInt(quantity_input.val());
    new_quantity = current_quantity + quantity_change;
    quantity_input.val(new_quantity).trigger('change');
    $(this).parent().find('[data-current-quantity]').html(new_quantity);
  });

  // AJAX cart

  if($('#shopify-section-custom-cart-drawer').length) {
    $(document).on('submit', '[data-enable-cart-drawer="true"] form[action="/cart/add"]', function(e) {
      e.preventDefault();
      const form = this;
      const clearCart = form.dataset.clearCart == 'true';
      if (clearCart) {
        fetch(theme.cartRoutes.cartClearUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;'
          }
        }).then(function(response) {
          return response.json();
        }).then(function(json) {
          if (json.status && json.status !== 200) {
            var error = new Error(json.description);
            error.isFromServer = true;
            throw error;
          }
          addItemToCart(form);
        }).catch(function(error) {
          console.log(error);
        });
      } else {
        addItemToCart(form);
      }
    });

    $(document).on('click', '[data-toggle-cart-drawer]', function(e) {
      e.preventDefault();
      $('html').toggleClass('disable-scroll cart-drawer-opened');
    });

    // $(document).on('click', '[data-remove-item]', function(e) {
    //   e.preventDefault();
    //   item_key = $(this).data('remove-item');
    //   bundle_instance = $(this).data('bundle-instance');

    //   if (bundle_instance) {
    //     removeBundleGroup(bundle_instance);
    //   } else {
    //     updateCartItem(item_key, 0);
    //   }
    // });
    $(document).on('click', '[data-remove-item]', function(e) {
      e.preventDefault();
      item_key = $(this).data('remove-item');
      bundle_instance = $(this).data('bundle-instance');
      bundle_instance_no_cascade = $(this).data('bundle-instance-no-cascade');

      if (bundle_instance && !bundle_instance_no_cascade) {
        removeBundleGroup(bundle_instance);
      } else {
        updateCartItem(item_key, 0);
      }
    });

    $(document).on('change', '[data-change-item-quantity]', function(e) {
      quantity = $(this).val();
      item_key = $(this).data('change-item-quantity');
      updateCartItem(item_key, quantity);
    });

    function updateCartItem(key, quantity) {
      let updates = {};
      updates[key] = quantity;
      var time = Date.now();
      fetch(`${theme.cartRoutes.cartUpdateUrl}.js?time=${time}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({updates})
      }).then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }
        renderCartDrawer();
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.log(error);
        alert(error);
        renderCartDrawer();
      });
    }

    function removeBundleGroup(bundleInstance) {
      let updates = {};

      $('.ccds-item').each(function() {
        var itemKey = $(this).data('cart-item-key');
        var itemBundleInstance = $(this).find('[data-remove-item]').data('bundle-instance');
        if (itemBundleInstance === bundleInstance) {
          updates[itemKey] = 0;
        }
      });

      if ($.isEmptyObject(updates)) {
        return;
      }

      var time = Date.now();
      fetch(`${theme.cartRoutes.cartUpdateUrl}.js?time=${time}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({updates})
      }).then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }
        renderCartDrawer();
      })
      .catch(function(error) {
        console.log(error);
        alert(error);
        renderCartDrawer();
      });
    }

    function addItemToCart(form) {
      let formData = new FormData(form);

      fetch(`${theme.cartRoutes.cartAddUrl}.js`, {
        method: 'POST',
        body: formData
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }
        renderCartDrawer();
        openCartDrawer();
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.log(error);
      });
    }

    function openCartDrawer() {
      $('html').addClass('disable-scroll cart-drawer-opened');
    }

    function renderCartDrawer() {
      var time = Date.now();
      fetch(`${theme.cartRoutes.cartUrl}?section_id=custom-cart-drawer&time=${time}`, {
        method: 'GET',
      }).then(function(response) {
        return response.text();
      }).then(function(text) {
        text_to_html = $.parseHTML(text);
        section_content = $(text_to_html).html();
        $('#shopify-section-custom-cart-drawer').html(section_content);
        new_cart_count = parseInt($('#shopify-section-custom-cart-drawer [data-current-cart-count]').data('current-cart-count'));
        if(new_cart_count > 0) {
          $('.ch-cart-link').addClass('not-empty');
        } else {
          $('.ch-cart-link').removeClass('not-empty');
        }
        $('[data-cart-count]').html(new_cart_count);
      });
    }

    $(document).on('change', '[name="subscription-switch"]', function() {
      input = $(this)[0];
      input.setAttribute('disabled', 'disabled');
      data_array = [];
      $('.ccds-container').attr('loading', '');
      if($(this)[0].checked){
        // Turn all applicable products to subscription
        $('.ccds-item[data-cart-item-is-subscription="false"][data-cart-item-has-subscription-plans="true"]').each((index,item) => {
          data = {
            line: parseInt(item.dataset.cartItemIndex),
            quantity: parseInt(item.dataset.cartItemQuantity),
            selling_plan: parseInt(item.dataset.cartItemFirstSubscriptionPlanId)
          }
          data_array.push(data);
        });
      } else {
        // Turn all applicable products to one-time purchase
        $('.ccds-item[data-cart-item-is-subscription="true"][data-cart-item-has-subscription-plans="true"]').each((index,item) => {
          data = {
            line: parseInt(item.dataset.cartItemIndex),
            quantity: parseInt(item.dataset.cartItemQuantity),
            selling_plan: null
          }
          data_array.push(data);
        });
      }
      fetchMultipleRequests(data_array, theme.cartRoutes.cartChangeUrl + '.js').then((allResponses) => {
        renderCartDrawer();
      }).catch(error => {
        console.log(error);
      })
    });

    $(document).on('submit', '[data-cart-drawer-upsell-form]', function(e) {
      e.preventDefault();
      $('.ccds-container').attr('loading', '');
      formData = theme.Helpers.serialize(this);
      baseItemKey = this.dataset.baseItemKey;

      // First remove the base item from cart
      let updates = {};
      updates[baseItemKey] = 0;
      fetch(theme.cartRoutes.cartUpdateUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({updates})
      }).then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }
        // Then add new upsell product
        fetch(`${theme.cartRoutes.cartAddUrl}.js`, {
          method: 'POST',
          body: formData
        })
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          if (json.status && json.status !== 200) {
            var error = new Error(json.description);
            error.isFromServer = true;
            throw error;
          }
          // GTM Upsell upgrade event
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: 'upsell_upgrade',
            ecommerce: {
              items: [
                {
                  item_id: json.product_id,
                  item_name: json.title,
                  item_brand: json.vendor,
                  item_variant: json.id,
                  currency: Shopify.currency.active,
                  price: json.price / 100
                }
              ]
            }
          });
          renderCartDrawer();
        })
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
        });
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.log(error);
      });
      console.log(baseItemKey);
    });

    window.renderCartDrawer = renderCartDrawer;
    window.openCartDrawer = openCartDrawer;
  }

  if ($('.cmarquee').length){
    function CalculateMarquee(windowWidth){
      $('.cmarquee').each(function(){
        var marqueeInner = $(this).find('.custom-marquee-inner');
        var marqueeParent = marqueeInner.parent();
        var marqueeInnerWidth = marqueeInner.width();
        var oldMarqueeParentWidth = marqueeParent.width();
        while (marqueeParent.width() - marqueeInnerWidth > windowWidth){
          $(this).find('.custom-marquee-inner')[0].remove();
        }
        while (marqueeParent.width() < windowWidth) {
          marqueeInner.clone(true).appendTo( marqueeParent );
          if(oldMarqueeParentWidth == marqueeParent.width()){
            break
          }
        }
        marqueeInnerLength = $(this).find('.custom-marquee-inner').length;
        marqueeParent.get(0).style.setProperty("--marquee_length", marqueeInnerLength);
      })
    }
    var windowWidth = $(window).width() * 2;
    CalculateMarquee(windowWidth);

    $(window).on('resize', function(){
      var windowWidth = $(window).width() * 2;
      CalculateMarquee(windowWidth);
    })
  }

  $(document).on('click', '[data-close-modal]', function(){
    $(this).parents('.custom-login-popup').addClass('hide');
  });
});

class ProductItem extends HTMLElement {
  constructor() {
    super();
    this.product_id = this.dataset.productId;
    this.elements = {
      optionButtons: this.querySelectorAll(`[data-variant-option][data-product-id="${this.product_id}"]`),
      price: this.querySelectorAll(`[data-variant-price][data-product-id="${this.product_id}"]`),
      compareAtPrice: this.querySelectorAll(`[data-variant-compare-at-price][data-product-id="${this.product_id}"]`),
      variantDiscount: this.querySelectorAll`[data-variant-discount][data-product-id="${this.product_id}"]`,
      subscriptionPrice: this.querySelector(`[data-variant-subscription-price][data-product-id="${this.product_id}"]`),
      subscriptionCompareAtPrice: this.querySelector(`[data-variant-subscription-compare-at-price][data-product-id="${this.product_id}"]`),
      submitButtons: this.querySelectorAll(`[data-product-item-submit-button][data-product-id="${this.product_id}"]`),
      featuredMedia: this.querySelector(`[data-featured-media][data-product-id="${this.product_id}"]`),
      links: this.querySelectorAll(`[data-variant-url][data-product-id="${this.product_id}"]`),
      purchaseOptions: this.querySelectorAll(`[name="purchase_option"][data-product-id="${this.product_id}"]`),
      sellingPlanSelector: this.querySelector(`[name="selling_plan_value"][data-product-id="${this.product_id}"]`),
      sellingPlanInput: this.querySelector(`[name="selling_plan"][data-product-id="${this.product_id}"]`),
      sellingPlanItems: this.querySelectorAll(`[data-selling-plan-item][data-product-id="${this.product_id}"]`),
      subscriptionDiscount: this.querySelector(`[data-variant-selling-plan-discount][data-product-id="${this.product_id}"]`),
    }
    this.product = JSON.parse(this.querySelector(`[data-product-json][data-product-id="${this.product_id}"]`).innerHTML);
    this.selectedVariant = this.getVariantById(this.querySelector(`[data-item-id][data-product-id="${this.product_id}"]`).value);
    this.selectedOptions = {
      option1: this.selectedVariant.option1,
      option2: this.selectedVariant.option2,
      option3: this.selectedVariant.option3
    };
    this.availableOptions = {};
    const sellingPlansContainer = this.querySelector('[data-selling-plans-container]');
    this.promoDiscount = sellingPlansContainer ? (parseInt(sellingPlansContainer.dataset.promoDiscount) || 0) : 0;

    if (this.product.options.length > 1) {
      this.updateAvailableOptionsBasedOnVariantId();
    }

    if(this.elements.optionButtons) {
      this.elements.optionButtons.forEach(
        (button) => button.addEventListener('click', this.updateOptions.bind(this))
      );
    }

    if (this.elements.sellingPlanInput) {
      if (this.elements.purchaseOptions) {
        this.elements.purchaseOptions.forEach(
          (option) => option.addEventListener('change', this.purchaseOptionChanged.bind(this))
        );
      }

      if (this.elements.sellingPlanSelector) {
        this.elements.sellingPlanSelector.addEventListener('change', this.planChanged.bind(this))
      }

      if (this.elements.sellingPlanInput.value) {
        const initialPlan = this.selectedVariant.selling_plan_allocations.find(
          (plan) => plan.selling_plan_id == this.elements.sellingPlanInput.value
        );
        if (initialPlan) {
          this.elements.submitButtons.forEach((button) => {
            const price = button.querySelector('[data-variant-price]');
            if (price) {
              price.innerHTML = Shopify.formatMoney(this.applyPromoDiscount(initialPlan.price));
            }
          });
        }
      }
    }
  }

  applyPromoDiscount(price) {
    if (!this.promoDiscount) return price;
    return price - Math.floor(price * this.promoDiscount / 100);
  }

  planChanged(event) {
    const value = event.target.value;
    this.elements.sellingPlanInput.value = value;
    const selectedPlan = this.selectedVariant.selling_plan_allocations.find((plan) => plan.selling_plan_id == value);
    const discountPercentage = ((selectedPlan.compare_at_price - selectedPlan.price) / selectedPlan.compare_at_price) * 100;
    const displayPrice = this.applyPromoDiscount(selectedPlan.price);

    this.elements.subscriptionPrice.innerHTML = Shopify.formatMoney(displayPrice);
    if (this.elements.subscriptionCompareAtPrice) {
      const compareAt = this.promoDiscount ? selectedPlan.price : selectedPlan.compare_at_price;
      this.elements.subscriptionCompareAtPrice.innerHTML = Shopify.formatMoney(compareAt);
    }
    this.elements.submitButtons.forEach((button) => {
      const price = button.querySelector('[data-variant-price]');
      if (price) {
        price.innerHTML = Shopify.formatMoney(displayPrice);
      }
    });

    if (discountPercentage && this.elements.subcriptionDiscount) {
      this.elements.subscriptionDiscount.innerHTML = theme.strings.subscriptionDiscount.replaceAll('[discount]', Math.floor(discountPercentage) + '%');
    }
  }

  purchaseOptionChanged(event) {
    const value = event.target.value;
    const planItem = event.target.parentNode;
    const _this = this;
    if (this.elements.sellingPlanItems) {
      this.elements.sellingPlanItems.forEach(
        (plan) => plan.classList.remove('active')
      );
    }
    planItem.classList.add('active');
    if(value == 'subscription') {
      this.elements.sellingPlanInput.value = this.elements.sellingPlanSelector.value;
    } else {
      this.elements.sellingPlanInput.value = '';
    }

    this.elements.submitButtons.forEach((button) => {
      const price = button.querySelector('[data-variant-price]');

      if (price) {
        if (value == 'subscription') {
          const selectedPlan = _this.selectedVariant.selling_plan_allocations.find(
            (plan) => plan.selling_plan_id == _this.elements.sellingPlanInput.value
          );
          price.innerHTML = Shopify.formatMoney(_this.applyPromoDiscount(selectedPlan.price));
        } else {
          price.innerHTML = Shopify.formatMoney(_this.applyPromoDiscount(_this.selectedVariant.price));
        }
      }
    })
  }

  updateOptions(event) {
    event.currentTarget.parentNode.childNodes.forEach(button => {
      button.setAttribute('aria-active', false);
    })
    event.currentTarget.setAttribute('aria-active', true);
    this.selectedOptions[event.currentTarget.dataset.optionPosition] = event.currentTarget.dataset.optionValue;
    this.selectedVariant = this.getOptionBasedVariant();
    this.updateVariant();
  }

  getOptionBasedVariant() {
    let variant = this.product.variants.find(variant => {
      return variant.option1 == this.selectedOptions.option1 && variant.option2 == this.selectedOptions.option2 && variant.option3 == this.selectedOptions.option3
    });
    return variant;
  }

  getVariantById(variantId) {
    return this.product.variants.find(variant => {
      return variant.id == variantId;
    })
  }

  getVariantsWithSameOptions() {
    var _this = this;
    let availableVariants = this.product.variants.filter(variant => {
      return variant.available == true;
    });

    let variantsWithSameOptions = availableVariants.filter(variant => {
      var willReturn = false;
      if (variant.option1 && ! willReturn) {
        willReturn = variant.option1 == _this.selectedOptions.option1;
      }
      if (variant.option2 && ! willReturn) {
        willReturn = variant.option2 == _this.selectedOptions.option2;
      }
      if (variant.option3 && ! willReturn) {
        willReturn = variant.option3 == _this.selectedOptions.option3;
      }
      return willReturn;
    });

    return variantsWithSameOptions;
  }

  updateVariant(){
    const _this = this;
    // Update selected options selected values
    for (const [key, value] of Object.entries(this.selectedOptions)) {
      this.querySelectorAll(`[data-product-id="${this.product_id}"][data-option-position="${key}"][data-option-selected-value]`).forEach(selectedValue => {
        selectedValue.innerHTML = value;
      })
    }
    // Set inputs id
    this.querySelectorAll(`[data-item-id][data-product-id="${this.product_id}"]`).forEach(input => {
      input.value = this.selectedVariant.id;
      input.dispatchEvent(new Event('change'));
    })
    // Update available options
    if (this.product.options.length > 1) {
      this.updateAvailableOptionsBasedOnVariantId();
    }
    // Update image
    if (this.selectedVariant.featured_media) {
      this.elements.featuredMedia?.setAttribute('src', this.selectedVariant.featured_media.preview_image.src);
      this.elements.featuredMedia?.setAttribute('srcset', this.selectedVariant.featured_media.preview_image.src);
    }
    // Update prices
    if (this.elements.price.length) {
      this.elements.price.forEach((element) => {
        element.innerHTML = Shopify.formatMoney(this.applyPromoDiscount(this.selectedVariant.price));
      })
      const onetimeCompareAt = this.querySelectorAll(`[data-variant-onetime-compare-at-price][data-product-id="${this.product_id}"]`);
      onetimeCompareAt.forEach((element) => {
        element.innerHTML = Shopify.formatMoney(this.selectedVariant.price);
      });
      if (this.elements.compareAtPrice.length) {
        this.elements.compareAtPrice.forEach((element) => {
          if (this.selectedVariant.compare_at_price > this.selectedVariant.price) {
            element.innerHTML = Shopify.formatMoney(this.selectedVariant.compare_at_price);
            element.style.display = 'block';
          } else {
            element.style.display = 'none';
          }
        })
      }

      if (this.elements.variantDiscount.length) {
        this.elements.variantDiscount.forEach((element) => {
          if (this.selectedVariant.compare_at_price > this.selectedVariant.price) {
            const saleValue = (this.selectedVariant.price / this.selectedVariant.compare_at_price) / 100;
            const salePercentage = Math.round(100 - saleValue);
            element.innerHTML = theme.strings.saleBadge.replaceAll('[sale_percentage]', `-${salePercentage}%`);
            element.style.display = 'block';
          } else {
            element.style.display = 'none';
          }
        });
      }
    }

    if (this.elements.subscriptionPrice && this.selectedVariant.selling_plan_allocations.length) {
      const selectedPlan = this.selectedVariant.selling_plan_allocations.find(
        (plan) => plan.selling_plan_id == _this.elements.sellingPlanInput.value
      );

      if (selectedPlan) {
        this.elements.subscriptionPrice.innerHTML = Shopify.formatMoney(this.applyPromoDiscount(selectedPlan.price));
        if (this.elements.subscriptionCompareAtPrice) {
          const compareAt = this.promoDiscount ? selectedPlan.price : selectedPlan.compare_at_price;
          this.elements.subscriptionCompareAtPrice.innerHTML = Shopify.formatMoney(compareAt);
        }

        if (_this.elements.sellingPlanInput && _this.elements.sellingPlanInput.value) {
          this.elements.submitButtons.forEach((button) => {
            const price = button.querySelector('[data-variant-price]');
            if (price) {
              price.innerHTML = Shopify.formatMoney(_this.applyPromoDiscount(selectedPlan.price));
            }
          });
        }
      }
    }

    // Update URL
    this.elements.links.forEach(link => {
      link.setAttribute('href', `/products/${this.product.handle}?variant=${this.selectedVariant.id}`);
    });
    // Update buttons
    this.elements.submitButtons.forEach(button => {
      if (this.selectedVariant.available) {
        button.removeAttribute('disabled');
        var buttonClassList = button.classList;
        var buttonText = '';
        switch (true) {
          case buttonClassList.contains('subscription'):
            buttonText = theme.strings.subscribe;
            break;
          case buttonClassList.contains('preorder'):
            buttonText = theme.strings.preorder;
            break;
          case buttonClassList.contains('is-in-drawer'):
            buttonText = theme.strings.drawerUpsellButton;
            break; 
          default:
            buttonText = theme.strings.addToCart;
        }

        button.querySelector('[data-submit-button-text]').innerHTML = buttonText;
      } else {
        button.setAttribute('disabled', true);
        button.querySelector('[data-submit-button-text]').innerHTML = theme.strings.soldOut;
      }
    });
    // Fire custom event
    this.dispatchEvent(new CustomEvent('updatedProductItemVariant', { detail: {
      variant: this.selectedVariant,
      product: this.product
    }}));
  }

  updateAvailableOptionsBasedOnVariantId() {
    let availableOptions = {
      option1: [],
      option2: [],
      option3: []
    };

    let variantsWithSameOptions = this.getVariantsWithSameOptions();

    for (var i = 1; i <= this.product.options.length; i ++) {
      [...variantsWithSameOptions].forEach(variant => {
        availableOptions[`option${i}`].push(variant[`option${i}`]);
      });

      // Leaving only unique values
      availableOptions[`option${i}`] = [...new Set(availableOptions[`option${i}`])];
    }

    this.updateAvailableOptions(availableOptions);
  }

  updateAvailableOptions(availableOptions) {
    this.elements.optionButtons.forEach(button => {
      button.disabled = !availableOptions[button.dataset.optionPosition].includes(button.dataset.optionValue);
    });
  }
}

customElements.define('product-item', ProductItem);


class ProductPage extends ProductItem {
  constructor() {
    super();
    this.imagesSlider = this.querySelector('[data-main-images-slider]');
    this.thumbnailsSlider = this.querySelector('[data-thumbnails-slider]');

    this.sliderNav = {
      prevButton: this.querySelector('[data-slider-nav="prev"]'),
      nextButton: this.querySelector('[data-slider-nav="next"]')
    }

    this.subscriptionAdditionalHTML = this.querySelector('[data-subscription-additional-html]');
    this.subscriptionContainer = this.querySelector('[data-custom-subscription-container]');

    if (this.imagesSlider) {
      this.thumbnails = this.querySelectorAll('[data-thumbnail]');

      if (this.thumbnails) {
        this.thumbnails.forEach(
          (thumbnail) => thumbnail.addEventListener('click', this.handleThumbnailClick.bind(this))
        )
      }
      this.initializeSlider();
    }

    this.addEventListener('updatedProductItemVariant', this.updateAdditionalInfo.bind(this));

    if (this.subscriptionAdditionalHTML && this.subscriptionContainer) {
      this.addSubscriptionAdditionalHTML();
    }
  }

  updateAdditionalInfo() {
    this.updateUrl();
    this.updatePricePerUnit();
    if (this.imagesSlider) {
      this.updateSliderImages();
    }
  }

  updateUrl() {
    var queryParams = new URLSearchParams(window.location.search);
    queryParams.set("variant", this.selectedVariant.id);
    var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + queryParams.toString();
    window.history.replaceState({ path: newUrl }, '', newUrl);
  }

  updatePricePerUnit() {
    var quantity_option_index = this.product.options.indexOf('Quantity') || this.product.options.indexOf('quantity');
    if (quantity_option_index > -1) {
      var quantity_option_value = parseInt(this.selectedVariant.options[quantity_option_index]);
      var one_time_price_per_unit = this.selectedVariant.price / quantity_option_value;
      this.style.setProperty('--one-time-price-per-unit', `'${Shopify.formatMoney(one_time_price_per_unit)}'`);
      if(this.selectedVariant.selling_plan_allocations.length) {
        var subscription_plan_price = this.selectedVariant.selling_plan_allocations[0].price;
        var subscription_plan_price_per_unit = subscription_plan_price / quantity_option_value;
        this.style.setProperty('--subscription-price-per-unit', `'${Shopify.formatMoney(subscription_plan_price_per_unit)}'`);
      }
    }
  }

  updateSliderImages() {
    if (this.selectedVariant.featured_media) {
      // this.filterImagesSlider($(this.imagesSlider).slick('getSlick'));
      var slideIndex = $(this.querySelector(`[data-main-media-id="${this.selectedVariant.featured_media.id}"]`)).index();
      $(this.imagesSlider).slick('slickGoTo', slideIndex);
    }
  }

  initializeSlider() {
    var _this = this;
    $(_this.imagesSlider).on('init', function(event, slick) {
      _this.updateActiveThumbnail(slick.currentSlide);
      if (_this.selectedVariant.featured_media) {
        // _this.filterImagesSlider(slick);
      }
    });

    $(_this.imagesSlider).slick({
      infinite: false,
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: _this.sliderNav.prevButton,
      nextArrow: _this.sliderNav.nextButton,
      adaptiveHeight: true,
      asNavFor: _this.thumbnailsSlider ? $(_this.thumbnailsSlider) : null,
      swipeToSlide: true,
    });

    $(_this.imagesSlider).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      _this.updateActiveThumbnail(nextSlide);
    });

    if (this.thumbnailsSlider) {
      $(_this.thumbnailsSlider).slick({
        infinite: false,
        dots: false,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: $(_this.imagesSlider),
        focusOnSelect: true,
        mobileFirst: true,
        vertical: true,
        verticalSwiping: true,
        swipeToSlide: true,
      });
    }
  }

  handleThumbnailClick(event) {
    event.preventDefault();
    const slideIndex = event.currentTarget.dataset.thumbnailIndex;
    this.imagesSlider.slick.slickGoTo(slideIndex);
  }

  updateActiveThumbnail(currentSlideIndex) {
    this.thumbnails.forEach(
      (thumbnail) => {
        const thumbnailIndex = thumbnail.dataset.thumbnailIndex;
        thumbnail.setAttribute('aria-active', thumbnailIndex == currentSlideIndex);
      }
    );
  }

  filterImagesSlider(slick) {
    var mediaAlt = this.selectedVariant.featured_media.alt || this.product.title;
    // slick.unfilterSlides();
    // slick.filterSlides(`[data-media-alt="${mediaAlt}"]`);
  }

  addSubscriptionAdditionalHTML() {
    var _this = this;
    // Select the node that will be observed for mutations
    const targetNode = this.subscriptionContainer;

    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: false };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.addedNodes[0].classList.contains('rc-container-wrapper')) {
          if (_this.subscriptionContainer.querySelector('[data-widget-container-wrapper] [data-plans-container]')) {
            _this.subscriptionContainer.querySelector('[data-widget-container-wrapper] [data-plans-container]').append(_this.subscriptionAdditionalHTML);
            observer.disconnect();
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }
}

customElements.define('product-page', ProductPage);

class TabItems extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('[id^="Tab-"]');
    this.tabsContent = this.querySelectorAll(`[id^="TabContent-"]`);

    this.tabs.forEach(
      (tab) => tab.addEventListener('click', this.showTab.bind(this))
    );
  }

  showTab(event) {
    this.tabs.forEach(tab => {
      tab.setAttribute('aria-active', false);
    })
    event.currentTarget.setAttribute('aria-active', true);
    var tabContentId = 'TabContent-' + event.currentTarget.id.replaceAll('Tab-', '');
    this.tabsContent.forEach(tabContent => {
      tabContent.style.display = 'none';
    });
    this.querySelector(`#${tabContentId}`).style.display = 'block';
  }
}

customElements.define('tab-items', TabItems);

class CartDrawerUpsellSlider extends HTMLElement {
  constructor() {
    super();
    this.itemsSlider = this.querySelector('[data-slider]');

    this.sliderNav = {
      prevButton: this.querySelector('[data-slider-nav="prev"]'),
      nextButton: this.querySelector('[data-slider-nav="next"]')
    }

    this.initializeSlider();
  }

  initializeSlider() {
    var _this = this;

    $(_this.itemsSlider).slick({
      infinite: false,
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: _this.sliderNav.prevButton,
      nextArrow: _this.sliderNav.nextButton,
      adaptiveHeight: true
    });
  }
}

customElements.define('cart-drawer-upsell-slider', CartDrawerUpsellSlider);

class SubscriptionProducts extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.productSelector = this.querySelector('[data-switch-subscription-product]');

    this.productSelector.addEventListener('change', this.changeSubscriptionProduct.bind(this));
  }

  changeSubscriptionProduct() {
    let _this = this;
    let productHandle = this.productSelector.value;
    fetch(theme.rootUrl + 'products/' + productHandle + '?section_id=' + this.sectionId, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      return response.text();
    }).then(function(text) {
      const div = document.createElement('div');
      div.innerHTML = text;
      let newContent = div.querySelector('subscription-products');
      _this.replaceWith(newContent);
    })
  }
}

customElements.define('subscription-products', SubscriptionProducts);

class ToggleableFaq extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      categories: this.querySelectorAll('[data-faq-category]'),
      questions: this.querySelectorAll('[data-faq-question]'),
    }

    if (this.elements.categories) {
      this.elements.categories.forEach((category) => {
        category.addEventListener('click', this.categorySelected.bind(this));
      });
    }
  }

  categorySelected(event) {
    this.elements.categories.forEach((category) => {
      category.setAttribute('aria-active', false);
    });

    event.target.setAttribute('aria-active', true);

    const category = event.target.dataset.showCategory;
    this.elements.questions.forEach((question) => {
      const question_category = question.dataset.parentCategory;
      if (question_category == category) {
        question.setAttribute('aria-hidden', false);
      } else {
        question.setAttribute('aria-hidden', true);
      }
    });
  }
}

customElements.define('toggleable-faq', ToggleableFaq);

class LogosSlider extends HTMLElement {
  constructor() {
    super();

    this.itemsSlider = this.querySelector('[data-slider]');
    this.slides = this.querySelectorAll('[data-slide]');

    this.sliderNav = {
      prevButton: this.querySelector('[data-slider-nav="prev"]'),
      nextButton: this.querySelector('[data-slider-nav="next"]')
    }

    this.checkIfOverflown();

    window.addEventListener('resize', this.checkIfOverflown.bind(this));
  }

  checkIfOverflown() {
    const infinite = this.itemsSlider.dataset.infinite == "true";
    const sliderInitialized = this.itemsSlider.classList.contains('slick-initialized');
  
    if (infinite) {
      if (!sliderInitialized) {
        this.initializeSlider();
        this.sliderNav.prevButton.removeAttribute('hidden');
        this.sliderNav.nextButton.removeAttribute('hidden');
      }
    } else {
      let slidesTotalWidth = 0;
      this.slides.forEach((slide) => {
        slidesTotalWidth += slide.clientWidth;
      });

      if (slidesTotalWidth > this.itemsSlider.clientWidth) {
        if (!sliderInitialized) {
          this.initializeSlider();
          this.sliderNav.prevButton.removeAttribute('hidden');
          this.sliderNav.nextButton.removeAttribute('hidden');
        }
      } else {
        if (sliderInitialized) {
          $(this.itemsSlider).slick('unslick');
          this.sliderNav.prevButton.setAttribute('hidden', 'hidden');
          this.sliderNav.nextButton.setAttribute('hidden', 'hidden');
        }
      }
    }
  }

  initializeSlider() {
    var _this = this;

    const autoplay = this.itemsSlider.dataset.autoplay == "true";
    const autoplaySpeed = this.itemsSlider.dataset.autoplaySpeed;
    const infinite = this.itemsSlider.dataset.infinite == "true";
    const centerMode = this.itemsSlider.dataset.centerMode == "true";

    $(_this.itemsSlider).slick({
      infinite: infinite,
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: _this.sliderNav.prevButton,
      nextArrow: _this.sliderNav.nextButton,
      variableWidth: true,
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      centerMode: centerMode,
      centerPadding: '0'
    });
  }
}

customElements.define('logos-slider', LogosSlider);


class ResultsSlider extends HTMLElement {
  constructor() {
    super();
    this.parentSection = this.closest('.shopify-section');

    this.hasVideos = this.dataset.hasVideos == 'true';
    this.openVideosInPopup = this.dataset.openVideosInPopup == 'true';
    this.itemsSlider = this.querySelector('[data-slider]');

    this.sliderNav = {
      prevButton: this.querySelector('[data-slider-nav="prev"]'),
      nextButton: this.querySelector('[data-slider-nav="next"]')
    }

    this.initializeSlider();

    if (this.hasVideos) {
      if (this.openVideosInPopup) {
        this.videoPopup = this.parentSection.querySelector('[data-video-popup]');
        this.videoPopupWrapper = this.videoPopup.querySelector('[data-video-popup-wrapper]');

        this.openVideoPopupButtons = this.parentSection.querySelectorAll('[data-open-video-popup]');
        this.openVideoPopupButtons.forEach(
          (button) => button.addEventListener('click', this.openVideoPopup.bind(this))
        );

        this.closeVideoPopupButtons = this.parentSection.querySelectorAll('[data-close-video-popup]');
        this.closeVideoPopupButtons.forEach(
          (button) => button.addEventListener('click', this.closeVideoPopup.bind(this))
        );
      } else {
        this.loadVideoButtons = this.parentSection.querySelectorAll('[data-load-video]');
        this.loadVideoButtons.forEach(
          (button) => button.addEventListener('click', this.loadVideo.bind(this))
        );
      }
      
    }
  }

  openVideoPopup(event) {
    const button = event.currentTarget;
    const videoUrl = button.dataset.videoUrl;

    const iframe = document.createElement('iframe');
    iframe.src = videoUrl;
    iframe.setAttribute('allow', 'autoplay; fullscreen');
    iframe.setAttribute('playsinline', 'playsinline');
    iframe.setAttribute('frameborder', 0);

    iframe.classList.add('custom-video');

    this.videoPopupWrapper.append(iframe);

    this.videoPopup.setAttribute('aria-hidden', false);

    document.querySelector('html').classList.add('disable-scroll');
  }

  closeVideoPopup(event) {
    this.videoPopupWrapper.innerHTML = '';

    this.videoPopup.setAttribute('aria-hidden', true);

    document.querySelector('html').classList.remove('disable-scroll');
  }

  loadVideo(event) {
    const button = event.currentTarget;
    const videoUrl = button.dataset.videoUrl;
    const videoContainer = button.closest('[data-video-container]');

    const iframe = document.createElement('iframe');
    iframe.src = videoUrl;
    iframe.setAttribute('allow', 'autoplay; fullscreen');
    iframe.setAttribute('playsinline', 'playsinline');
    iframe.setAttribute('frameborder', 0);

    iframe.classList.add('custom-video', 'with-background');

    videoContainer.append(iframe);
  }

  initializeSlider() {
    var _this = this;

    const autoplay = this.itemsSlider.dataset.autoplay == "true";
    const autoplaySpeed = this.itemsSlider.dataset.autoplaySpeed;
    const shiftSlider = this.itemsSlider.dataset.shiftSlider == "true";
    const hideArrowsMobile = this.itemsSlider.dataset.hideArrowsMobile == "true";

    $(_this.itemsSlider).slick({
      infinite: false,
      dots: false,
      arrows: hideArrowsMobile ? false :true,
      slidesToShow: shiftSlider ? 1.25 : 1,
      slidesToScroll: 1,
      prevArrow: _this.sliderNav.prevButton,
      nextArrow: _this.sliderNav.nextButton,
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      adaptiveHeight: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            arrows: true,
            slidesToShow: shiftSlider ? 1.5 : 2,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
            slidesToShow: shiftSlider ? 2.65 : 3,
          }
        },
      ]
    });
  }
}

customElements.define('results-slider', ResultsSlider);

class CustomCollection extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;

    this.elements = {
      filters: {
        drawer: this.querySelector('[data-filters-drawer]'),
        drawerCloseButtons: this.querySelectorAll('[data-close-filters-drawer]'),
        drawerOpenButtons: this.querySelectorAll('[data-open-filters-drawer]'),
        form: this.querySelector('[data-filters-form]'),
      },
      productsCount: this.querySelector('[data-products-count]'),
      gridContainer: this.querySelector('[data-grid-container]'),
      grid: this.querySelector('[data-grid]'),
    }

    if (this.elements.filters.drawer) {
      this.attachFiltersRelatedListeners();
    }
  }

  attachFiltersRelatedListeners() {
    this.elements.filters.drawerOpenButtons.forEach(
      (button) => button.addEventListener('click', this.openFiltersDrawer.bind(this))
    );

    this.elements.filters.drawerCloseButtons.forEach(
      (button) => button.addEventListener('click', this.closeFiltersDrawer.bind(this))
    );

    this.elements.filters.form.addEventListener('submit', this.handleFiltersFormSubmit.bind(this));
  }

  openFiltersDrawer(event) {
    if (event) {
      event.preventDefault();
    }
    
    document.querySelector('html').classList.add('disable-scroll');
    this.elements.filters.drawer.setAttribute('aria-hidden', false);
  }

  closeFiltersDrawer(event) {
    if (event) {
      event.preventDefault();
    }

    document.querySelector('html').classList.remove('disable-scroll');
    this.elements.filters.drawer.setAttribute('aria-hidden', true);
  }

  handleFiltersFormSubmit(event) {
    event.preventDefault();
    let _this = this;
    const searchParams = this.createSearchParams(event.target);
    const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;
    this.elements.filters.form.setAttribute('loading', 'loading');
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        const responseSectionHTML = new DOMParser().parseFromString(html, 'text/html');
        
        _this.elements.filters.form.removeAttribute('loading');
        _this.elements.productsCount.innerHTML = responseSectionHTML.querySelector('[data-products-count]').innerHTML;
        _this.elements.gridContainer.innerHTML = responseSectionHTML.querySelector('[data-grid-container]').innerHTML;
        _this.closeFiltersDrawer();
        // if (AOS) {
        //   AOS.refreshHard();
        // }
        _this.updateURLHash(searchParams);
      });
  }
  
  updateURLHash(searchParams) {
    history.replaceState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }
}

customElements.define('custom-collection', CustomCollection);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class ProductVariations extends HTMLElement {
  constructor() {
    super();
    this.parentSection = this.closest('.shopify-section');
    this.sectionId = this.dataset.sectionId;
    this.parentProductItem = this.closest('product-item') || this.closest('product-page');

    this.buttons = this.querySelectorAll('[data-product-variation-button]');

    if (this.buttons) {
      this.buttons.forEach(
        (button) => button.addEventListener('click', this.handleButtonClick.bind(this))
      );
    }
  }

  handleButtonClick(event) {
    event.preventDefault();
    let _this = this;
    const clickedButton = event.currentTarget;

    this.buttons.forEach(
      (button) => button.setAttribute('aria-active', button == clickedButton)
    );

    const product = JSON.parse(clickedButton.querySelector('[data-variation-product-json]').innerHTML);
    const selectedVariant = product.variants.find(
      (variant) => JSON.stringify(variant.options) == JSON.stringify(_this.parentProductItem.selectedVariant.options)
    ) || product.variants[0];

    const urlForHistoryUpdate = clickedButton.dataset.productUrl + '?variant=' + selectedVariant.id;
    const finalUrl = urlForHistoryUpdate + '&section_id=' + this.sectionId;

    fetch(finalUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      return response.text();
    }).then(function(text) {
      const div = document.createElement('div');
      div.innerHTML = text;

      const newParentProductItem = div.querySelector(_this.parentProductItem.nodeName.toLowerCase());
      _this.parentProductItem.replaceWith(newParentProductItem);
      // if (AOS) {
      //   AOS.refreshHard();
      // }
      window.history.replaceState({ path: urlForHistoryUpdate }, '', urlForHistoryUpdate);
    })
  }
}

customElements.define('product-item-variations', ProductVariations);

class VideoContainer extends HTMLElement {
  constructor() {
    super();
    this.videoContainer = this.querySelector('[data-video-container]');
    this.loadVideoButton = this.querySelector('[data-load-video]');
    this.videoPoster = this.querySelector('[data-video-poster]');

    if (this.loadVideoButton) {
      this.loadVideoButton.addEventListener('click', this.loadVideo.bind(this));
    }
  }

  loadVideo() {
    const videoUrl = this.loadVideoButton.dataset.videoUrl;
    const iframe = document.createElement('iframe');
    iframe.src = videoUrl;
    iframe.setAttribute('allow', 'autoplay; fullscreen');
    iframe.setAttribute('playsinline', 'playsinline');
    iframe.setAttribute('frameborder', 0);

    iframe.classList.add('z-index-1', 'absolute', 'inset-0', 'width-full', 'height-full');

    if (this.videoPoster) {
      this.videoPoster.classList.add('opacity-0');
    }

    this.videoContainer.append(iframe);
  }
}

customElements.define('video-container', VideoContainer);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.itemsSlider = this.querySelector('[data-slider]');
    this.sliderNav = {
      prevButton: this.querySelector('[data-slider-nav="prev"]'),
      nextButton: this.querySelector('[data-slider-nav="next"]')
    }

    if (this.itemsSlider) {
      this.initializeSlider();
    }
  }

  initializeSlider() {
    var _this = this;

    const autoplay = this.itemsSlider.dataset.autoplay == "true";
    const autoplaySpeed = this.itemsSlider.dataset.autoplaySpeed;

    $(_this.itemsSlider).slick({
      infinite: true,
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: _this.sliderNav.prevButton,
      nextArrow: _this.sliderNav.nextButton,
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      adaptiveHeight: true,
      mobileFirst: true,
      vertical: true,
      verticalSwipe: true,
    });
  }
}

customElements.define('announcement-bar', AnnouncementBar);

class SearchDrawer extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      container: this.querySelector('[data-search-container]'),
      openers: document.querySelectorAll('[data-open-search-drawer]'),
      closers: document.querySelectorAll('[data-close-search-drawer]'),
      input: this.querySelector('[data-search-input]')
    }

    if (this.elements.openers) {
      this.elements.openers.forEach(
        (opener) => opener.addEventListener('click', this.openDrawer.bind(this))
      );
    }

    if (this.elements.closers) {
      this.elements.closers.forEach(
        (closer) => closer.addEventListener('click', this.closeDrawer.bind(this))
      );
    }

    this.addEventListener('keyup', this.keyupHandler.bind(this))
  }

  openDrawer(event) {
    if (event) {
      event.preventDefault();
    }
    var _this = this;
    
    this.setAttribute('aria-hidden', false);

    // deselect any focused form elements
    document.activeElement.dispatchEvent(
      new CustomEvent('blur', { bubbles: true, cancelable: true })
    );

    // Set focus on drawer input
    const trapFocusConfig = {
      container: _this.elements.container,
      elementToFocus: _this.elements.input,
    };

    setTimeout(function() {
      slate.a11y.trapFocus(trapFocusConfig);
    }, 500)
    

    const mobileMenu = document.querySelector('.mobile-menu-container');
    mobileMenu.classList.remove('opened');

    const customHeaderContainer = document.querySelector('.ch-container');
    customHeaderContainer.classList.remove('mobile-menu-opened');

    const html = document.querySelector('html');
    html.classList.add('disable-scroll');
  }

  closeDrawer(event) {
    if (event) {
      event.preventDefault();
    }
    var _this = this;
    
    this.setAttribute('aria-hidden', true);

    // deselect any focused form elements
    document.activeElement.dispatchEvent(
      new CustomEvent('blur', { bubbles: true, cancelable: true })
    );

    // Remove focus on drawer input
    setTimeout(function() {
      slate.a11y.removeTrapFocus({
        container: _this.elements.container,
      });
    }, 500)

    const html = document.querySelector('html');
    html.classList.remove('disable-scroll');
  }

  keyupHandler(event) {
    if (event.keyCode === 27) {
      this.closeDrawer();
      return false;
    } else {
      return true;
    }
  }
}

customElements.define('search-drawer', SearchDrawer);